import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Segment } from '@feathr/blackbox';
import { Button, ModalV1 } from '@feathr/components';
import { useToggle } from '@feathr/hooks';

import ConversionPixelCode from './ConversionPixelCode';

interface IProps {
  segment: Segment;
}

function ConversionPixelCodeCell({ segment }: Readonly<IProps>): JSX.Element {
  const [showCodeModal, toggleCodeModal] = useToggle(false);
  const { t } = useTranslation();

  return (
    <>
      <Button onClick={toggleCodeModal}>{t('Show')}</Button>
      {showCodeModal && (
        <ModalV1
          confirmButtonText={t('Ok')}
          controlled={true}
          onClose={toggleCodeModal}
          t={t}
          title={t('Conversion Pixel')}
        >
          <ConversionPixelCode segment={segment} />
        </ModalV1>
      )}
    </>
  );
}

export default ConversionPixelCodeCell;
